import { render, staticRenderFns } from "./swpConfinedSpace.vue?vue&type=template&id=510caf58"
import script from "./swpConfinedSpace.vue?vue&type=script&lang=js"
export * from "./swpConfinedSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('510caf58')) {
      api.createRecord('510caf58', component.options)
    } else {
      api.reload('510caf58', component.options)
    }
    module.hot.accept("./swpConfinedSpace.vue?vue&type=template&id=510caf58", function () {
      api.rerender('510caf58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/swp/swpConfinedSpace.vue"
export default component.exports